module.exports = __webpack_public_path__ + "static/media/70-iveco-mercedes.16e351fe.jpg";